<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <data-table
          :filters="filters"
          :limit="10"
          :applyUrlFilters="true"
          url="/notification_schedules"
          content="notificationScheduleList"
          container-classes="px-4 pt-2"
        >
          <template slot="title">
            <v-layout row wrap>
              <v-flex md9>
                <p class="headline mt-3">Gestión diaria</p>
              </v-flex>
              <v-flex md1 class="text-xs-right ml-auto">
                <v-menu bottom offset-y>
                  <v-btn slot="activator" color="grey darken-2" flat fab>
                    <v-icon class="f2em">fas fa-cog</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile @click="showCompanyLoad = true">
                      <v-list-tile-title>Programación diaria</v-list-tile-title>
                    </v-list-tile>
                    <!--<v-list-tile @click="uploadFile()">
                      <v-list-tile-title>Cargar Archivo</v-list-tile-title>
                    </v-list-tile>-->
                    <v-list-tile @click="commuteNotifications(11)">
                      <v-list-tile-title>Parar</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="commuteNotifications(29)">
                      <v-list-tile-title>Reanudar</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row wrap mt-2 mb-4>
              <v-flex :xs3="!isWhatsappOutboundActive" pr-3>
                <v-card
                  :class="{
                    'elevation-3': true,
                    'k-orange-linear': filters.channel === 4,
                    hovered: filters.channel !== 4,
                  }"
                  height="95px"
                >
                  <v-card-text @click="filters.channel = 4">
                    <v-layout justify-center align-center>
                      <v-flex xs4>
                        <v-avatar size="60" class="transparent">
                          <v-icon
                            large
                            :class="{
                              'k-orange-linear-text': filters.channel !== 4,
                              'white--text': filters.channel === 4,
                            }"
                            >fas fa-robot</v-icon
                          >
                        </v-avatar>
                      </v-flex>
                      <v-flex xs8>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'white--text': filters.channel === 4,
                            }"
                          >
                            Bot
                          </v-flex>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'grey--text': filters.channel !== 4,
                              'white--text': filters.channel === 4,
                            }"
                            v-if="channels.bot"
                          >
                            {{ channels.bot }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex :xs3="!isWhatsappOutboundActive" pr-3>
                <v-card
                  :class="{
                    'elevation-3': true,
                    'k-orange-linear': filters.channel === 1,
                    hovered: filters.channel !== 1,
                  }"
                  height="95px"
                >
                  <v-card-text @click="filters.channel = 1">
                    <v-layout justify-center align-center>
                      <v-flex xs4>
                        <v-avatar size="60" class="transparent">
                          <v-icon
                            large
                            :class="{
                              'k-orange-linear-text': filters.channel !== 1,
                              'white--text': filters.channel === 1,
                            }"
                            >fas fa-envelope</v-icon
                          >
                        </v-avatar>
                      </v-flex>
                      <v-flex xs8>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'white--text': filters.channel === 1,
                            }"
                          >
                            Email
                          </v-flex>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'grey--text': filters.channel !== 1,
                              'white--text': filters.channel === 1,
                            }"
                            v-if="channels.email"
                          >
                            {{ channels.email }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex :xs3="!isWhatsappOutboundActive" pr-3>
                <v-card
                  :class="{
                    'elevation-3': true,
                    'k-orange-linear': filters.channel === 3,
                    hovered: filters.channel !== 3,
                  }"
                  height="95px"
                >
                  <v-card-text @click="filters.channel = 3">
                    <v-layout justify-center align-center>
                      <v-flex xs4>
                        <v-avatar size="60" class="transparent">
                          <v-icon
                            large
                            :class="{
                              'k-orange-linear-text': filters.channel !== 3,
                              'white--text': filters.channel === 3,
                            }"
                            >fas fa-phone fa-rotate-90</v-icon
                          >
                        </v-avatar>
                      </v-flex>
                      <v-flex xs8>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'white--text': filters.channel === 3,
                            }"
                          >
                            IVR
                          </v-flex>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'grey--text': filters.channel !== 3,
                              'white--text': filters.channel === 3,
                            }"
                            v-if="channels.ivr"
                          >
                            {{ channels.ivr }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex
                :xs3="!isWhatsappOutboundActive"
                :pr-3="isWhatsappOutboundActive"
              >
                <v-card
                  :class="{
                    'elevation-3': true,
                    'k-orange-linear': filters.channel === 2,
                    hovered: filters.channel !== 2,
                  }"
                  height="95px"
                >
                  <v-card-text @click="filters.channel = 2">
                    <v-layout justify-center align-center>
                      <v-flex xs4>
                        <v-avatar size="60" class="transparent">
                          <v-icon
                            large
                            :class="{
                              'k-orange-linear-text': filters.channel !== 2,
                              'white--text': filters.channel === 2,
                            }"
                            >fas fa-comments</v-icon
                          >
                        </v-avatar>
                      </v-flex>
                      <v-flex xs8>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'white--text': filters.channel === 2,
                            }"
                          >
                            SMS
                          </v-flex>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'grey--text': filters.channel !== 2,
                              'white--text': filters.channel === 2,
                            }"
                            v-if="channels.sms"
                          >
                            {{ channels.sms }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="isWhatsappOutboundActive">
                <v-card
                  :class="{
                    'elevation-3': true,
                    'k-orange-linear': filters.channel === 7,
                    hovered: filters.channel !== 7,
                  }"
                  height="95px"
                >
                  <v-card-text @click="filters.channel = 7">
                    <v-layout justify-center align-center>
                      <v-flex xs4>
                        <v-avatar size="60" class="transparent">
                          <v-icon
                            large
                            :class="{
                              'k-orange-linear-text': filters.channel !== 7,
                              'white--text': filters.channel === 7,
                            }"
                            >fab fa-whatsapp</v-icon
                          >
                        </v-avatar>
                      </v-flex>
                      <v-flex xs8>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'white--text': filters.channel === 7,
                            }"
                          >
                            WhatsApp
                          </v-flex>
                          <v-flex
                            xs12
                            :class="{
                              headline: true,
                              'grey--text': filters.channel !== 7,
                              'white--text': filters.channel === 7,
                            }"
                            v-if="channels.whatsapp"
                          >
                            {{ channels.whatsapp }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
          <template slot="navigation-bar">
            <v-flex lg3>
              <v-text-field
                v-model="filters.search"
                label="Buscar..."
                color="black"
                solo
              >
              </v-text-field>
            </v-flex>
            <v-flex lg3 pl-2>
              <v-select
                v-model="filters.reviewed_at"
                :items="reviews"
                class="white--text"
                color="grey"
                solo
              >
              </v-select>
            </v-flex>
            <v-flex lg3 pl-2>
              <v-select
                v-model="filters.status"
                :items="statuses"
                item-value="value"
                item-text="status"
                class="white--text"
                color="grey"
                solo
              >
                <template slot="selection" slot-scope="data">
                  <div class="black--text">
                    {{ data.item.status }} ({{ data.item.total }})
                  </div>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content
                      v-text="data.item"
                    ></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ data.item.status }} ({{
                          data.item.total
                        }})</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </v-flex>
            <v-flex lg3 pl-2>
              <v-menu
                ref="from"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="filters.date"
                transition="scale-transition"
                min-width="290px"
                lazy
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  v-model="dateMinFormatted"
                  class="k-orange-linear-text"
                  prepend-icon="event"
                  label="Desde"
                  readonly
                  solo
                >
                </v-text-field>
                <v-date-picker
                  v-model="filters.date"
                  @input="$refs.from.save(filters.date)"
                  locale="es"
                  color="k-orange-linear"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
        </data-table>
        <notification-schedule-detail></notification-schedule-detail>
      </v-flex>
    </v-layout>
    <save-dialog
      :title="dialogTitle"
      :dialog="dialog"
      :form="form"
      route="notification_schedules/commute"
      :edit="false"
      :hasMore="false"
      :more="false"
    >
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              v-model="form.channel"
              v-validate="'required'"
              data-vv-name="channel"
              data-vv-as="canal"
              :error-messages="errors.collect('channel')"
              :items="channelsList"
              label="Canal"
              color="black"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <!--
    <upload-file-dialog :show="showUpload" @close="showUpload = false">
    </upload-file-dialog>
    -->
    <company-load-dialog
      :show="showCompanyLoad"
      @save="companyLoadSelected"
      @close="showCompanyLoad = false"
    />
    <company-load-detail-dialog
      :show="showcompanyLoadDetailDialog"
      :company-load="companyLoad"
      @close="showcompanyLoadDetailDialog = false"
    />
  </v-container>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import EventBus from "@/event-bus";
import DataTable from "@/components/global/DataTable";
import notificationScheduleList from "@/components/notification_schedule/NotificationScheduleList";
import SaveDialog from "@/components/global/SaveDialog";
import saveDialogMixin from "@/mixins/saveDialog";
import NotificationScheduleDetail from "@/components/notification_schedule/Detail";
import CompanyLoadDialog from "@/components/CompanyLoad/Dialog";
import CompanyLoadDetailDialog from "@/components/CompanyLoad/Detail";
import UploadFileDialog from "@/components/notification_schedule/UploadFileDialog";
import { mapGetters } from "vuex";

Vue.component("notificationScheduleList", notificationScheduleList);

export default {
  components: {
    DataTable,
    SaveDialog,
    NotificationScheduleDetail,
    CompanyLoadDialog,
    CompanyLoadDetailDialog,
    UploadFileDialog,
  },
  mixins: [saveDialogMixin],
  // beforeRouteEnter(to, from, next) {
  //   Vue.axios
  //     .get("check_release", { params: { name: "whatsapp_outbound_project" } })
  //     .then(({ data }) => {
  //       next((vm) => {
  //         vm.isWhatsappOutboundActive = data.is_active;
  //       });
  //     });
  // },
  data() {
    return {
      from: false,
      to: false,
      stopMusic: false,
      showUpload: false,
      isWhatsappOutboundActive: true,
      filters: {
        type: 1,
        dateType: "date",
        search: "",
        channel: 4,
        ignore_programmed: false,
        date: moment().format("YYYY-MM-DD"),
        status: "",
        sort: "-date",
        reviewed_at: "",
      },
      activeNotificationSchedule: 0,
      channels: {},
      cancelToken: {},
      statuses: [
        {
          status: "Estados",
          value: "",
          total: 0,
        },
      ],
      reviews: [
        {
          text: "Todos (0)",
          value: "",
        },
        {
          text: "Sin revisar (0)",
          value: "empty",
        },
        {
          text: "Revisados (0)",
          value: "notEmpty",
        },
      ],
      form: {
        status: "",
        channel: "",
      },
      dialogType: "stop",
      channel: 0,
      showCompanyLoad: false,
      showcompanyLoadDetailDialog: false,
      companyLoad: {},
    };
  },
  computed: {
    dateMinFormatted() {
      return moment(this.filters.date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    dialogTitle() {
      return `${this.form.status === 11 ? "Parar" : "Reanudar"} notificaciones`;
    },
    channelsList() {
      const includedChannels = [1, 2, 3, 4, 5];
      if (this.isWhatsappOutboundActive) {
        includedChannels.push(7);
      }
      let channel = this.channelStore.filter((channel) =>
        includedChannels.includes(channel.id)
      );
      channel = channel.map((x) => ({
        value: x.id,
        text: x.channel.charAt(0).toUpperCase() + x.channel.slice(1),
      }));
      return channel;
    },
    ...mapGetters({
      channelStore: "channels",
    }),
  },
  created() {
    /*
    EventBus.$on('update', () => {
      // this.updateChannelsMetrics();
    });
    */
    EventBus.$on("rightDrawerSaved", () => {
      EventBus.$emit("update");
    });
  },
  mounted() {
    this.updateStatus();
  },
  destroyed() {
    // EventBus.$off('update');
    EventBus.$off("showNotificationDetail");
    EventBus.$off("rightDrawerSaved");
  },
  methods: {
    companyLoadSelected(companyLoad) {
      this.companyLoad = companyLoad;
      this.showcompanyLoadDetailDialog = true;
    },
    generateReport() {
      this.$store.commit(
        "SET_DOWNLOAD_CHANNEL",
        `company.${this.$auth.user().company.id}.${
          this.$auth.user().id
        }.download_report`
      );
      this.$store.dispatch("SEND_DOWNLOAD_REQUEST", {
        route: "reports",
        params: {
          filters: this.filters,
          functionName: "managementTotal",
        },
      });
    },
    commuteNotifications(status) {
      this.dialog = true;
      setTimeout(() => {
        this.form.status = status;
      }, 3);
    },
    updateStatus() {
      if (!Object.keys(this.cancelToken).length) {
        this.cancelToken = this.axios.CancelToken.source();
      } else {
        this.cancelToken.cancel("");
        this.cancelToken = this.axios.CancelToken.source();
      }
      this.axios
        .get("notification_schedules/live_status", {
          cancelToken: this.cancelToken.token,
          params: {
            ...this.filters,
            status: "",
          },
        })
        .then((response) => {
          this.statuses = response.data;
          const totalStatus = this.sum("total", this.statuses);
          this.statuses.unshift({
            status: "Estados",
            value: "",
            total: totalStatus,
          });
        });
      this.axios
        .get("notification_schedules/reviews", {
          cancelToken: this.cancelToken.token,
          params: {
            ...this.filters,
          },
        })
        .then((response) => {
          this.reviews[1].text = `Sin revisar (${response.data.unreviewed})`;
          this.reviews[2].text = `Revisados (${response.data.reviewed})`;
          this.reviews[0].text = `Todos (${
            parseInt(response.data.unreviewed) +
            parseInt(response.data.reviewed)
          })`; // eslint-disable-line
        })
        .catch(() => {});
    },
    // updateChannelsMetrics() {
    //   this.axios.get(`notification_schedules/channels?date=${this.filters.date}`, {
    //     cancelToken: this.cancelToken.token,
    //   }).then((response) => {
    //     this.channels = response.data;
    //   }).catch(() => {});
    // },
    sum(prop, array) {
      let total = 0;
      for (let i = 0; i < array.length; i += 1) {
        total += array[i][prop];
      }
      return total;
    },
    uploadFile() {
      this.showUpload = true;
    },
  },
  watch: {
    filters: {
      handler() {
        this.updateStatus();
      },
      deep: true,
    },
    "filters.date"() {
      // eslint-disable-line
      // this.updateChannelMetrics();
    },
  },
};
</script>

<style scoped>
.card.elevation-3.hovered:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.05) !important;
  transition: 0.2s ease-in;
}
</style>



// WEBPACK FOOTER //
// src/components/notification_schedule/Index.vue